import type { ScratchcardDetails, ScratchcardPayTable, ScratchcardPayTablesResponse } from '../types';

function resolveScratchcardByMappingPath(scratchcards: ScratchcardDetails[], scratchcardName: string): ScratchcardDetails | undefined {
  return scratchcards.find(scratchcard => scratchcard.mappingPath === scratchcardName);
}

function resolveScratchcardPayTable(payTablesResponse: ScratchcardPayTablesResponse | null, scratchcard: ScratchcardDetails): ScratchcardPayTable[] {
  const tables = payTablesResponse?.scratchcardPayTables ?? {};
  const candidateKeys = [scratchcard.title, scratchcard.gameCode, scratchcard.mappingPath];

  for (const key of candidateKeys) {
    if (!key) {
      continue;
    }

    const match = tables[key];
    if (match) {
      return match;
    }
  }

  return scratchcard.payTables ?? [];
}

export { resolveScratchcardByMappingPath, resolveScratchcardPayTable };
